type urlFunctionType = (args: APIURLArgs) => string;

type urlsType = any;

type urlsCreatorsType = Record<string, urlFunctionType>;
type plainUrlsType = Record<string, string>;

interface ReturnType {
  urlCreators: urlsCreatorsType;
  plainUrls: plainUrlsType;
}

export function getUrlResources(
  sections: urlsType[],
  type: string = "",
): ReturnType {
  const urls: urlsType = sections.reduce(
    (reduced: urlsType, section: urlsType) => ({
      ...reduced,
      ...(type ? section[type] : section),
    }),
    {},
  );

  const urlCreators: urlsCreatorsType = {};
  const plainUrls: plainUrlsType = {};

  Object.keys(urls).forEach((urlName: string) => {
    if (urls[urlName] instanceof Function) {
      urlCreators[urlName] = urls[urlName] as urlFunctionType;
      return;
    }
    plainUrls[urlName] = urls[urlName] as string;
  });

  return { urlCreators, plainUrls };
}

export function createQueryString(
  params: Record<string, string> | URLSearchParams,
) {
  return new URLSearchParams(params).toString();
}

export function createFilterRoute(
  pathname: string,
  params: Record<string, string>,
) {
  return `${pathname}?${createQueryString(params)}`;
}
